import React from 'react';

const OrbitalAnimation = ({ progress = 0 }) => {
  const angle = (progress / 100) * 360;
  
  return (
    <div className="relative w-40 h-40">
      {/* Orbit Path */}
      <svg className="w-full h-full" viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          r="40"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.5"
          className="text-cosmic-300"
          strokeDasharray="3 3"
        />
      </svg>
      
      {/* Moving Planet */}
      <div
        className="absolute w-6 h-6 rounded-full shadow-cosmic transition-all duration-1000 ease-out"
        style={{
          top: '50%',
          left: '50%',
          transform: `translate(-50%, -50%) rotate(${angle}deg) translateX(80px)`,
          background: 'linear-gradient(135deg, #9b7de8 0%, #7d5fd1 100%)',
        }}
      >
        <div className="w-full h-full bg-sacred-400 rounded-full animate-pulse opacity-60" />
      </div>
      
      {/* Center Star */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div className="w-3 h-3 bg-sacred-400 rounded-full shadow-sacred" />
      </div>
    </div>
  );
};

export default OrbitalAnimation;